import {
  CLEAR_ORDER_VALUES,
  SET_NOTIFICATION_LOCKED_SEAT_DEPARTURE,
  SET_NOTIFICATION_LOCKED_SEAT_RETURN,
  UPDATE_PASSENGERS_DEPARTURE_CREATE_ORDER,
  UPDATE_PASSENGERS_RETURN_CREATE_ORDER,
  UPDATE_SEARCH_BOOKING_VALUES,
  UPDATE_SEGMENTS_DEPARTURE_CREATE_ORDER,
  UPDATE_SEGMENTS_RETURN_CREATE_ORDER,
} from "../types";

export const updateSearchBookingValues = (data) => {
  return {
    type: UPDATE_SEARCH_BOOKING_VALUES,
    payload: data,
  };
};

export const updatePassengerDeparture = (data) => {
  return {
    type: UPDATE_PASSENGERS_DEPARTURE_CREATE_ORDER,
    payload: data,
  };
};

export const updatePassengerReturn = (data) => {
  return {
    type: UPDATE_PASSENGERS_RETURN_CREATE_ORDER,
    payload: data,
  };
};

export const updateSegmentDeparture = (data) => {
  return {
    type: UPDATE_SEGMENTS_DEPARTURE_CREATE_ORDER,
    payload: data,
  };
};

export const updateSegmentReturn = (data) => {
  return {
    type: UPDATE_SEGMENTS_RETURN_CREATE_ORDER,
    payload: data,
  };
};
export const clearOrderValues = (data) => {
  return {
    type: CLEAR_ORDER_VALUES,
    payload: data,
  };
};
export const setNotifiSeatLockedDeparture = (data) => {
  return {
    type: SET_NOTIFICATION_LOCKED_SEAT_DEPARTURE,
    payload: data,
  };
};
export const setNotifiSeatLockedReturn = (data) => {
  return {
    type: SET_NOTIFICATION_LOCKED_SEAT_RETURN,
    payload: data,
  };
};
